import { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';

import CompanyApi from 'api/company';
import AuthHelper from '@youfy/shared/helpers/AuthHelper';
import { useAuth } from 'providers/auth';

const CompanySelect = props => {
  const authData = useAuth();
  const me = authData.me || {};

  const company = me.company || {};
  const companyValue = { label: company.name, value: company.id, ...company };

  const [value, setValue] = useState({});
  const [defaultValue, setDefaultValue] = useState(companyValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const loadOptions = (input_value, callback) => {
    CompanyApi.fetch().then(data => {
      const options = data.map(item => {
        return {
          value: item.id,
          label: item.name,
          ...item,
        };
      });

      setDefaultValue(options.find(item => item.id === company.id));
      callback(options.filter(item => item.name.toLowerCase().includes(input_value.toLowerCase())));
    });
  };

  const onChange = option => {
    AuthHelper.setCompany(option.value);
    window.location = '/';
    // setValue(option);
  };

  if (!me.is_holder) {
    return null;
  }

  return (
    <div className={`ms-3 ${props.containerClassName}`} style={{ width: 160 }}>
      <AsyncSelect
        placeholder="Empresa"
        className="company-select select"
        classNamePrefix="select"
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={value}
        onChange={onChange}
        {...props}
      />
    </div>
  );
};
export default CompanySelect;
